import {
  CreateMonthlyBillAPIResponse,
  DeleteMonthlyBillAPIResponse,
} from '../../../services/monthlyBills'
import { BaseReducerState, MonthlyBill } from '../../../services'
import { ActionTypes } from '../actions'

export type DeleteMonthlyBillState = BaseReducerState & {
  data: null
}

export const initialState: DeleteMonthlyBillState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const deleteMonthlyBill = (
  state: DeleteMonthlyBillState = initialState,
  action: { type: string; res: any }
): DeleteMonthlyBillState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_MONTHLY_BILL}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.DELETE_MONTHLY_BILL}_SUCCESS`: {
      const { success, data, message } = <DeleteMonthlyBillAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
      }
    }
    case `${ActionTypes.DELETE_MONTHLY_BILL}_FAILURE`:
      const res = <DeleteMonthlyBillAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.DELETE_MONTHLY_BILL}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
